import { Star } from "lucide-react";
import { cn } from "@/lib/utils";
import { useState } from "react";

interface StarRatingProps {
  value: number;
  onChange: (rating: number) => void;
  disabled?: boolean;
}

export const StarRating = ({ value, onChange, disabled }: StarRatingProps) => {
  const [hoveredStar, setHoveredStar] = useState<number | null>(null);

  const displayValue = hoveredStar !== null ? hoveredStar : value;

  return (
    <div className="flex gap-1" role="radiogroup" aria-label="Avaliação de 1 a 5 estrelas">
      {[1, 2, 3, 4, 5].map((rating) => (
        <button
          key={rating}
          type="button"
          role="radio"
          aria-checked={value === rating}
          aria-label={`${rating} ${rating === 1 ? 'estrela' : 'estrelas'}`}
          disabled={disabled}
          onClick={() => onChange(rating)}
          onMouseEnter={() => !disabled && setHoveredStar(rating)}
          onMouseLeave={() => setHoveredStar(null)}
          className={cn(
            "transition-all hover:scale-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded",
            disabled && "cursor-not-allowed opacity-50"
          )}
        >
          <Star
            className={cn(
              "h-8 w-8 transition-colors",
              displayValue >= rating
                ? "fill-yellow-400 text-yellow-400"
                : "fill-none text-muted-foreground"
            )}
          />
        </button>
      ))}
    </div>
  );
};
